import ComponentLoader from 'components/ComponentLoader'
import React from 'react'
import { logUtil } from 'packages/src'

function importPlanWorkoutComponent () {
  return import(/* webpackChunkName: "modules/workout/redux/containers/PlanWorkout" */ 'pages/PlanWorkout')
}

export default function getPlanWorkoutComponentRouteUtil (props) {
  logUtil('getPlanWorkoutComponentRouteUtil').debug('props=', props)

  if (WORKOUT || (SERVER && global.WORKOUT)) {
    const PlanWorkout = require('pages/PlanWorkout').default
    return <PlanWorkout {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={importPlanWorkoutComponent}
        {...props}
      />
    )
  }
}
